const stats = [
  { value: '4,000', unit: '원/일', label: '업계 최저 수수료', note: '최소 10,000원 · 최대 100,000원', icon: 'ri-money-dollar-circle-line' },
  { value: '24', unit: '시간', label: '긴급 대응 체계', note: '', icon: 'ri-time-line' },
  { value: '100', unit: '%', label: '보험서류 발급 처리', note: '', icon: 'ri-file-shield-2-line' },
  { value: '1:1', unit: '', label: '고객 맞춤 매칭', note: '', icon: 'ri-user-heart-line' },
];

export default function IntroStats() {
  return (
    <section className="w-full py-16" style={{ backgroundColor: '#0d2b24' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#6fcfb8' }}>WHY KOREA CARERS</p>
          <h2 className="text-2xl md:text-3xl font-bold text-white">코리아케어러스가 다른 이유</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl mx-auto mb-4" style={{ backgroundColor: 'rgba(46,125,107,0.3)' }}>
                <i className={`${s.icon} text-xl`} style={{ color: '#6fcfb8' }}></i>
              </div>
              <div className="flex items-baseline justify-center gap-1 mb-1">
                <span className="text-3xl md:text-4xl font-bold text-white">{s.value}</span>
                {s.unit && (
                  <span className="text-sm font-semibold" style={{ color: '#6fcfb8' }}>{s.unit}</span>
                )}
              </div>
              <p className="text-xs" style={{ color: 'rgba(255,255,255,0.45)' }}>{s.label}</p>
              {s.note && (
                <p className="text-[10px] mt-1 font-semibold" style={{ color: '#6fcfb8' }}>{s.note}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
